module.exports = __webpack_public_path__ + "img/report-8.43ea2e26.jpg";